import { z } from 'zod';

export const ControlVariableTransformationType = z
  .enum(['none', 'log', 'mean', 'last'])
  .describe('ControlVariableTransformationType');

export type ControlVariableTransformationType = z.infer<
  typeof ControlVariableTransformationType
>;

export const ControlVariableTransformationTypes = Object.values(
  ControlVariableTransformationType.Values,
);
